import { AbstractControl, ValidatorFn } from '@angular/forms'
import validator from 'validator'

export const urlValidator: ValidatorFn = (control: AbstractControl) => {
  return control.value && !validator.isURL(control.value) ? { invalidUrl: true } : null
}
